import { render, staticRenderFns } from "./DeliverableListUsers.vue?vue&type=template&id=190b3bd6&"
import script from "./DeliverableListUsers.vue?vue&type=script&lang=js&"
export * from "./DeliverableListUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports